// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sentiment-container {
  width: 100%;
  min-width: 328px;
  box-sizing: border-box;
  container-type: inline-size;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
}

.sentiment-symbol {
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: var(--text-primary);
  margin-bottom: 4px;
}

.sentiment-body {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 24px;
}

.sentiment-chart-container {
  flex: 1 1 0;
  min-width: 0;
  width: 100%;
  max-width: 600px;
  display: flex;
  align-self: center;
  flex-direction: column;
}

.sentiment-period-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: auto;
  height: 40px;
  margin: 0 24px;
  gap: 2px;
  padding: 4px;
  box-sizing: border-box;
  background: var(--surface-secondary);
  border-radius: 24px;
}

.sentiment-period-option {
  appearance: none;
  flex: 1;
  min-width: 0;
  width: 100%;
  height: 100%;
  padding: 4px 6px;
  border: none;
  border-radius: 16px;
  background: transparent;
  color: var(--text-primary);
  font-size: 16px;
  border-width: 2px;
  font-weight: 400;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    color 0.15s ease;
}

.sentiment-period-option.active {
  background: var(--color-brand);
  font-weight: 700;
  color: var(--text-invert);
}

.sentiment-period-option:disabled {
  cursor: not-allowed;
  color: var(--text-tertiary);
}

.sentiment-period-label--short {
  display: none;
}

.sentiment-gauge-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 2 / 1;
  min-height: 110px;
  max-height: 200px;
  margin-top: 24px;
  align-self: center;
}

.sentiment-info-button {
  position: absolute;
  top: 0;
  right: 24px;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--text-primary);
}

.sentiment-info-button svg {
  width: 100%;
  height: 100%;
  display: block;
}

.sentiment-info-text {
  font-size: 16px;
  line-height: 24px;
  color: var(--text-primary);
  text-align: left;
}

.sentiment-info-text p {
  margin-block-start: 0;
  margin-block-end: 1em;
}

.sentiment-bar-wrapper {
  width: 100%;
  margin-top: 8px;
  box-sizing: border-box;
  align-self: center;
}

.sentiment-charts-caption {
  margin-top: 4px;
  font-size: 12px;
  color: var(--text-secondary);
  font-weight: 400;
  text-align: center;
}

.sentiment-table {
  flex: 1 1 0;
  min-width: 0;
  width: 100%;
  margin-top: 64px;
  display: flex;
  flex-direction: column;
  font-size: 16px;
}

.sentiment-table-header {
  display: flex;
  align-items: center;
  padding: 7px 0;
  font-weight: 700;
  min-height: 32px;
  box-sizing: border-box;
  position: relative;
}

.sentiment-table-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 24px;
  right: 24px;
  border-bottom: 1px solid var(--border-line);
}

.sentiment-table-title,
.sentiment-table-latest {
  color: var(--text-subheader);
}

.sentiment-table-latest {
  margin-left: auto;
}

.sentiment-table-rows {
  display: flex;
  flex-direction: column;
}

.sentiment-table-row {
  display: grid;
  grid-template-columns: 24px 80px 1fr auto 24px;
  min-height: 40px;
  box-sizing: border-box;
  align-items: center;
  padding: 8px 0;
  position: relative;
}

.sentiment-table-row::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 24px;
  right: 24px;
  border-bottom: 1px solid var(--border-tertiary);
}

.sentiment-table-row:last-child::after {
  border-bottom: none;
}

.sentiment-table-period {
  color: var(--text-secondary);
}

.sentiment-table-label {
  min-width: 0;
  color: var(--text-primary);
}

.sentiment-table-score {
  text-align: right;
}

.sentiment-table-score.up {
  color: var(--text-up-color);
}

.sentiment-table-score.down {
  color: var(--text-down-color);
}

.sentiment-table-score.neutral {
  color: var(--text-unchg-color);
}

@container (max-width: 768px) {
  .sentiment-body {
    flex-direction: column;
  }

  .sentiment-table {
    margin-top: 8px;
  }
}

@container (max-width: 340px) {
  .sentiment-period-group {
    margin: 0 16px;
  }

  .sentiment-period-option {
    font-size: 14px;
    padding: 4px 4px;
  }

  .sentiment-period-label--full {
    display: none;
  }

  .sentiment-period-label--short {
    display: inline;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/SentimentWidget/SentimentWidget.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,cAAc;EACd,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf;;oBAEkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,2CAA2C;AAC7C;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".sentiment-container {\n  width: 100%;\n  min-width: 328px;\n  box-sizing: border-box;\n  container-type: inline-size;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n}\n\n.sentiment-symbol {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 24px;\n  color: var(--text-primary);\n  margin-bottom: 4px;\n}\n\n.sentiment-body {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  gap: 24px;\n}\n\n.sentiment-chart-container {\n  flex: 1 1 0;\n  min-width: 0;\n  width: 100%;\n  max-width: 600px;\n  display: flex;\n  align-self: center;\n  flex-direction: column;\n}\n\n.sentiment-period-group {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: auto;\n  height: 40px;\n  margin: 0 24px;\n  gap: 2px;\n  padding: 4px;\n  box-sizing: border-box;\n  background: var(--surface-secondary);\n  border-radius: 24px;\n}\n\n.sentiment-period-option {\n  appearance: none;\n  flex: 1;\n  min-width: 0;\n  width: 100%;\n  height: 100%;\n  padding: 4px 6px;\n  border: none;\n  border-radius: 16px;\n  background: transparent;\n  color: var(--text-primary);\n  font-size: 16px;\n  border-width: 2px;\n  font-weight: 400;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    color 0.15s ease;\n}\n\n.sentiment-period-option.active {\n  background: var(--color-brand);\n  font-weight: 700;\n  color: var(--text-invert);\n}\n\n.sentiment-period-option:disabled {\n  cursor: not-allowed;\n  color: var(--text-tertiary);\n}\n\n.sentiment-period-label--short {\n  display: none;\n}\n\n.sentiment-gauge-wrapper {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 2 / 1;\n  min-height: 110px;\n  max-height: 200px;\n  margin-top: 24px;\n  align-self: center;\n}\n\n.sentiment-info-button {\n  position: absolute;\n  top: 0;\n  right: 24px;\n  z-index: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: var(--text-primary);\n}\n\n.sentiment-info-button svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.sentiment-info-text {\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-primary);\n  text-align: left;\n}\n\n.sentiment-info-text p {\n  margin-block-start: 0;\n  margin-block-end: 1em;\n}\n\n.sentiment-bar-wrapper {\n  width: 100%;\n  margin-top: 8px;\n  box-sizing: border-box;\n  align-self: center;\n}\n\n.sentiment-charts-caption {\n  margin-top: 4px;\n  font-size: 12px;\n  color: var(--text-secondary);\n  font-weight: 400;\n  text-align: center;\n}\n\n.sentiment-table {\n  flex: 1 1 0;\n  min-width: 0;\n  width: 100%;\n  margin-top: 64px;\n  display: flex;\n  flex-direction: column;\n  font-size: 16px;\n}\n\n.sentiment-table-header {\n  display: flex;\n  align-items: center;\n  padding: 7px 0;\n  font-weight: 700;\n  min-height: 32px;\n  box-sizing: border-box;\n  position: relative;\n}\n\n.sentiment-table-header::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 24px;\n  right: 24px;\n  border-bottom: 1px solid var(--border-line);\n}\n\n.sentiment-table-title,\n.sentiment-table-latest {\n  color: var(--text-subheader);\n}\n\n.sentiment-table-latest {\n  margin-left: auto;\n}\n\n.sentiment-table-rows {\n  display: flex;\n  flex-direction: column;\n}\n\n.sentiment-table-row {\n  display: grid;\n  grid-template-columns: 24px 80px 1fr auto 24px;\n  min-height: 40px;\n  box-sizing: border-box;\n  align-items: center;\n  padding: 8px 0;\n  position: relative;\n}\n\n.sentiment-table-row::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 24px;\n  right: 24px;\n  border-bottom: 1px solid var(--border-tertiary);\n}\n\n.sentiment-table-row:last-child::after {\n  border-bottom: none;\n}\n\n.sentiment-table-period {\n  color: var(--text-secondary);\n}\n\n.sentiment-table-label {\n  min-width: 0;\n  color: var(--text-primary);\n}\n\n.sentiment-table-score {\n  text-align: right;\n}\n\n.sentiment-table-score.up {\n  color: var(--text-up-color);\n}\n\n.sentiment-table-score.down {\n  color: var(--text-down-color);\n}\n\n.sentiment-table-score.neutral {\n  color: var(--text-unchg-color);\n}\n\n@container (max-width: 768px) {\n  .sentiment-body {\n    flex-direction: column;\n  }\n\n  .sentiment-table {\n    margin-top: 8px;\n  }\n}\n\n@container (max-width: 340px) {\n  .sentiment-period-group {\n    margin: 0 16px;\n  }\n\n  .sentiment-period-option {\n    font-size: 14px;\n    padding: 4px 4px;\n  }\n\n  .sentiment-period-label--full {\n    display: none;\n  }\n\n  .sentiment-period-label--short {\n    display: inline;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
